module.exports = __webpack_public_path__ + "static/media/img-login-right.1af6d670.png";